import type { Session } from '../../../../core/domain/Session';
import { goToImageById, refreshImageLandmark, retrieveAnnotationsForCurrentImage } from '../../../../core/legacy/actions';
import { currentImageIdQuery } from '../../../../core/streetViewer/queries';
import { currentImagePositionResolved } from '../../../../core/streetViewer/state';

import { useAppDispatch, useAppSelector } from '../../../../types';
import useQueryParams from '../../../../utils/use-query-params';

const useGoToImageById = (session: Session | null): (() => void) => {
    const dispatch = useAppDispatch();
    const routeQueryParams: URLSearchParams = useQueryParams();
    const storedCurrentImageId = useAppSelector(currentImageIdQuery);

    const goToId = (): void => {
        const ImageIdQueryParam = routeQueryParams.get('imageId');
        if (ImageIdQueryParam) {
            dispatch(goToImageById(ImageIdQueryParam));

            return;
        }
        if (session && storedCurrentImageId && session.id === storedCurrentImageId.sessionId) {
            dispatch(goToImageById(storedCurrentImageId.imageId));

            return;
        }

        // No position to correct to (fresh open, no stored/deep-linked position) -
        // the current image stays at its default, but annotations still need loading.
        dispatch(currentImagePositionResolved());
        dispatch(retrieveAnnotationsForCurrentImage());
        dispatch(refreshImageLandmark());
    };

    return goToId;
};

export default useGoToImageById;
